module.exports = __webpack_public_path__ + "img/城关镇.d2bbf82b.png";